import type { TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';
import { useKeysetPages } from '../useKeysetPages.ts';
import type { Customer, CustomerFilters } from './customers.ts';

const PAGE_SIZE = 50;

const pageQuery = (filters: CustomerFilters, pageToken: string | null) => ({
  page_size: PAGE_SIZE,
  ...(filters.governorate === null ? {} : { governorate: filters.governorate }),
  ...(filters.city === null ? {} : { city: filters.city }),
  ...(pageToken === null ? {} : { page_token: pageToken }),
});

export const useCustomerList = (api: TypedClient, filters: CustomerFilters, phone: string | null) => {
  const { tenantId } = usePageContext();
  const list = useKeysetPages<Customer>({
    queryKey: queryKeys.customers(tenantId, { ...filters, searching: phone !== null, phone }),
    resource: 'orders',
    fetchPage: (pageToken) => {
      const query = pageQuery(filters, pageToken);
      return phone === null
        ? api.get('/admin/customers', { query })
        : api.post('/admin/customers/search', { body: { ...query, phone } });
    },
  });
  return { ...list, customers: list.items };
};
